import { Box, type BoxProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

type PageHeadingProps = Omit<BoxProps, 'children' | 'as'> & {
  children: ReactNode;
  as?: 'h1' | 'h2' | 'h3';
};

export function PageHeading({ children, as = 'h1', ...props }: PageHeadingProps) {
  return (
    <Box as={as} fontSize="2xl" lineHeight={pxToRem(32)} fontWeight="medium" {...props}>
      {children}
    </Box>
  );
}
